import { useSelector } from "react-redux";
import { getListstStore } from "@/store/lists/actions";

export const useContactListsNamesMap = (): Map<string, string> => {
    const { listNamesCollection } = useSelector(getListstStore);

    const namesMap = new Map();

    listNamesCollection?.forEach((list) => {
        namesMap.set(list.PublicListID,list.ListName);
    });

    return namesMap;
}
